<template>
  <div id="list-with-elements" class="col-md-9">
    <div id="jobslistcontainer">
      <div class="row">
        <slot name="header" />
      </div>
      <div v-if="!haveElements" class="text-center">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <DisplaySkeleton />
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <DisplaySkeleton />
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <DisplaySkeleton />
      </div>
      <div v-else id="profile-list-results" class="profile-list">
        <slot />
      </div>
      <div class="row">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListerTemplate',
  props: {
    haveElements: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      bottom: false,
    }
  },
  watch: {
    bottom(bottom) {
      if (bottom && this.haveElements) {
        this.$emit('hitBottom')
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.bottomVisible)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.bottomVisible)
  },
  methods: {
    bottomVisible() {
      const scrollY = window.pageYOffset
      const visible = document.documentElement ? document.documentElement.clientHeight : 0
      const listHeight = document.getElementById('list-with-elements').scrollHeight
      const bottomOfPage = visible + scrollY >= listHeight
      this.bottom = bottomOfPage
    },
  },
}
</script>

<style scoped lang="scss">
#list-with-elements {
  min-height: 500px;
}
</style>
